import React from "react";
import { Row, Col } from "antd";
import LastSevenDayInvoice from "../../components/chart/lastSevenDayInvoice";
import ElectricTransaction from "../../components/chart/electricTransaction";
import { getMerchantId } from "service/storage";

const MerchantDashboard = () => {
  const merchantId = getMerchantId();

  return (
    <div style={{ height: "95vh", overflow: "auto", padding: "20px" }}>
      <Row gutter={16}>
        <Col span={24}>
          <LastSevenDayInvoice merchantId={merchantId} />
        </Col>
        {merchantId === 1 && (
          <Col span={12}>
            <ElectricTransaction />
          </Col>
        )}
      </Row>
    </div>
  );
};

export default MerchantDashboard;
